import React, { Component } from 'react';

import Infinite from 'react-infinite';
import { DeclareItem, DeclareMailItem, Loading } from 'components';
import { injectIntl, defineMessages } from 'react-intl';
import { Image } from 'semantic-ui-react';

import styles from './Declare.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class DeclareList extends Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const filterUpdateCheck = this.props.filterUpdate;
    if (filterUpdateCheck) {
      return filterUpdateCheck;
    } else {
      return filterUpdateCheck;
    }
  }

  // 태그 선택시 대상자 rerender 처리
  componentDidUpdate(prevProps, prevState) {
    // 대상자 Height 설정
    // 데이터가 없으면 rf.scrollable이 아예 생성 안됨
    const rf = this.refScroll;
    if (!!rf && !!rf.scrollable) {
      const { heightData, numberOfChildren } = rf.state.infiniteComputer;
      const isScroll = heightData * numberOfChildren > rf.scrollable.parentElement.clientHeight;

      // 높이가 달라진 경우
      // 스크롤이 생성 여부
      if (
        rf.computedProps.containerHeight !== rf.scrollable.parentElement.clientHeight ||
        isScroll !== this.state.declareScrollData['isScroll']
      ) {
        this.setState({
          declareScrollData: { isScroll: isScroll, height: rf.scrollable.parentElement.clientHeight }
        });
      }
    }

    const { needReload, selectedTag, targetParam, currentPath } = this.props;
    if (
      // 대상자 새로고침
      (needReload && !this.state.isLoading) ||
      // 선택한 태그가 변경되었을 때
      selectedTag !== prevProps.selectedTag ||
      // parameter가 변경되었을때
      targetParam !== prevProps.targetParam
    ) {
      if (currentPath === '/main/declaration/exam') {
        this.onGetDeclare(true);
      }

      // 새로고침시 스크롤 맨위로 이동
      if (!!rf && !!rf.scrollable) {
        rf.scrollable.scrollTop = 0;
        // rf.infiniteHandleScroll(0);
        // rf.handleScroll(0);
      }
    }
  }

  render() {
    const { formatMessage } = this.props.intl;
    const {
      declareOrdering,
      tagDataByTagNo,
      declareDataByTargetNo,
      selectDeclareTargetNo,
      handleSelectDeclare,
      declareScrollData,
      onRefScroll,
      page,
      totalPages,
      onGetDeclare,
      onGetDeclareMail,
      isLoading,
      currentPath
    } = this.props;


    const isMail = currentPath === '/main/declaration/mail';

    const targetComponent = declareOrdering.map(
      // 컴포넌트로 매핑
      (targetNo, i) => {
        if (isMail) {
          return (
            !!declareDataByTargetNo.get(String(targetNo)) && (
              <DeclareMailItem
                key={i}
                tagDataByTagNo={tagDataByTagNo}
                target={declareDataByTargetNo.get(String(targetNo))}
                selectDeclareTargetNo={selectDeclareTargetNo}
                handleSelectDeclare={handleSelectDeclare}
              />
            )
          );
        } else {
          return (
            !!declareDataByTargetNo.get(String(targetNo)) && (
              <DeclareItem
                key={i}
                tagDataByTagNo={tagDataByTagNo}
                target={declareDataByTargetNo.get(String(targetNo))}
                selectDeclareTargetNo={selectDeclareTargetNo}
                handleSelectDeclare={handleSelectDeclare}
              />
            )
          );
        }
      }
    );

    return (
      <div className={cx('target-content')}>
        <div className={cx('target-content-inner')}>
          {targetComponent.size > 0 ? (
            <Infinite
              className={cx({ noScroll: !declareScrollData['isScroll'] })}
              ref={Infinite => {
                onRefScroll(Infinite);
              }}
              containerHeight={declareScrollData['height']}
              elementHeight={41}
              infiniteLoadBeginEdgeOffset={200}
              timeScrollStateLastsForAfterUserScrolls={1000}
              onInfiniteLoad={page !== totalPages ? (isMail ? onGetDeclareMail : onGetDeclare) : () => { }}
              loadingSpinnerDelegate={
                isLoading && (
                  <div className={cx('targetLoading')}>
                    <Loading content={'Loading...'} />
                  </div>
                )
              }
              isInfiniteLoading={isLoading}>
              {targetComponent}
            </Infinite>
          ) : (
              <div className={cx('noScroll', 'noTarget')}>
                <div className={cx('noScroll-icon-area')}>
                  <Image src="/img/exam/list_noTarget.png" />
                </div>
                <div>
                  <div className={cx('noScroll-title')}>
                    {defineMessages(formatMessage({ id: 'Declare_13', defaultMessage: '신고 이력이 없습니다' }))}
                  </div>
                  <div className={cx('noScroll-subTitle')}>
                    {defineMessages(formatMessage({ id: 'Declare_14', defaultMessage: '신고한 훈련 대상이 없습니다.' }))}
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default injectIntl(DeclareList);



// WEBPACK FOOTER //
// ./src/script/components/declare/DeclareList.js